import { isDefined } from "@ls/js-utils";
import scope from "state/analytics/scope";
import CalcType from "state/Constants/CalcType";
import ScaleType from "state/Constants/ScaleType";

export default class AnalyticDefinition {
  #analytic;
  #scaleType;
  #calcType;

  constructor(props = {}) {
    const { analytic, scaleType, calcType } = props;
    this.#analytic = analytic;
    this.#scaleType = scaleType;
    this.#calcType = calcType;
  }

  get analytic() {
    return this.#analytic;
  }

  get scaleType() {
    return this.#scaleType;
  }

  get calcType() {
    return this.#calcType;
  }

  get key() {
    return `${scope} - ${this.#analytic}, ${this.#calcType}, ${
      this.#scaleType
    }`;
  }

  get complete() {
    return (
      isDefined(this.#analytic) &&
      isDefined(this.#scaleType) &&
      isDefined(this.#calcType)
    );
  }

  static getDefault = () =>
    new AnalyticDefinition({
      analytic: "weight",
      calcType: CalcType.Account,
      scaleType: ScaleType.Contribution,
    });
  copy = () => ({
    analytic: this.#analytic,
    calcType: this.#calcType,
    scaleType: this.#scaleType,
  });
  setAnalytic = (value) =>
    new AnalyticDefinition({
      ...this.copy(),
      analytic: value,
    });
  setCalcType = (value) =>
    new AnalyticDefinition({
      ...this.copy(),
      calcType: value,
    });
  setScaleType = (value) => {
    const newDefinition = new AnalyticDefinition({
      ...this.copy(),
      scaleType: value,
    });

    // If scale type is RATIO, automatically change calcType to Relative
    if (value === ScaleType.Ratio) {
      return new AnalyticDefinition({
        ...newDefinition.copy(),
        calcType: CalcType.Relative,
      });
    }

    return newDefinition;
  };
}
